import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './YearChange.css';
/**
 * YearChange
 * -------------------------------------------------
 * Componente responsive que permite seleccionar y activar
 * un nuevo año de presupuesto.  Cambia automáticamente
 */
function YearChange({ status_year_change, yearChange, setSelectedYear, loader }) {
  const [selectedYear, setSelectedYearLocal] = useState(null);

  // Sincronizar estado local con Redux/props
  useEffect(() => {
    if (status_year_change && status_year_change.current_year !== undefined) {
      setSelectedYearLocal(status_year_change.current_year);
    }
  }, [status_year_change]);

  if (!status_year_change) {
    return (
      <div className="container-sm py-5">
        <div className="card shadow border-0 rounded-4 p-4">
          <div className="skeleton-line w-75 mb-3" />
          <div className="skeleton-line w-50 mb-2" />
          <div className="skeleton-line w-25" />
        </div>
      </div>
    );
  }

  const {
    is_active,
    can_activate,
    message,
    available_years,
    current_year,
    year: budgetYear,
    system_year,
  } = status_year_change;

  // Opciones para react-select
  const yearOptions = available_years.map((yr) => ({
    label: `${yr}${yr === budgetYear ? ' (año actual)' : ''}`,
    value: yr,
  }));

  // Valor seleccionado para react-select
  const selectedOption = yearOptions.find(opt => opt.value === selectedYear) || null;

  // Handler para react-select
  const handleYearChange = (option) => {
    const yr = option ? option.value : null;
    setSelectedYearLocal(yr);
    setSelectedYear(yr);
  };

  return (
    <div className="container-sm my-5">
      <div className="card shadow border-0 rounded-4">
        {/* TITULAR */}
        <div className="card-header bg-white text-center py-3">
          <i className="bi bi-calendar3 text-primary me-2 fs-4" />
          <h2 className="h4 d-inline align-middle m-0">
            Cambio de año del presupuesto
          </h2>
        </div>

        <div className="card-body">
          {/* SELECTOR DE AÑO (react-select) */}
          <div className="mb-4 text-center" style={{ maxWidth: 350, margin: '0 auto' }}>
            <label htmlFor="yearSelector" className="form-label fw-bold mb-2">
              Seleccionar año de trabajo:
            </label>
            <Select
              inputId="yearSelector"
              classNamePrefix="react-select"
              options={yearOptions}
              value={selectedOption}
              onChange={handleYearChange}
              isDisabled={loader}
              isSearchable={false}
              placeholder="Selecciona un año..."
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  borderRadius: '1.5rem',
                  fontSize: '1.1rem',
                  minHeight: '48px',
                  border: state.isFocused ? '2px solid #0d6efd' : '1px solid #ced4da',
                  boxShadow: state.isFocused ? '0 0 0 0.2rem #b6d4fe' : 'none',
                }),
                option: (provided, state) => ({
                  ...provided,
                  fontWeight: state.isSelected ? 700 : 500,
                  color: state.isSelected ? '#fff' : '#0d6efd',
                  background: state.isSelected ? '#0d6efd' : '#fff',
                  fontSize: '1.1rem',
                }),
              }}
            />
          </div>

          {/* CHIPS */}
          <div className="d-flex flex-column flex-sm-row gap-2 mb-4 justify-content-center">
            <span className="chip chip-gray">
              <span className="chip-label">Año en curso:</span> <strong>{system_year}</strong>
            </span>
            <span className="chip chip-blue">
              <span className="chip-label">Año del presupuesto:</span> <strong>{budgetYear}</strong>
            </span>
            <span className="chip chip-green">
              <span className="chip-label">Año seleccionado para trabajar:</span> <strong>{current_year}</strong>
            </span>
          </div>

          {/* MENSAJE */}
          {message && (
            <div className="callout mb-4 mx-auto">{message}</div>
          )}

          {/* CTA */}
          {(!is_active && can_activate) && (
            <div className="text-center">
              <button
                className="btn btn-primary px-4 py-2"
                onClick={() => {
                    yearChange()
                }}
              >
                Cambiar año del presupuesto
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

YearChange.propTypes = {
  status_year_change: PropTypes.object,
  yearChange: PropTypes.func.isRequired,
  setSelectedYear: PropTypes.func.isRequired,
  loader: PropTypes.bool,
};

export default YearChange;
